import { z } from "zod"
import type { DeepPartialNullable } from "/js/types/PartialTypes"

export const ZGptMessageTextGenerate = z.object({
  text: z.string(),
})

export type GptMessageTextGenerate = z.infer<typeof ZGptMessageTextGenerate>

export type PartialGptMessageTextGenerate = DeepPartialNullable<GptMessageTextGenerate>